export const createPhotoFormData = (file, type, tempUuid) => {
  const formData = new FormData();
  formData.append('photo[type]', type);
  formData.append('photo[file]', file);

  if (tempUuid) {
    formData.append('photo[temp_uuid]', tempUuid);
  }

  return formData;
};